import { render, staticRenderFns } from "./DropZoneTableList.vue?vue&type=template&id=41fcb112&"
import script from "./DropZoneTableList.vue?vue&type=script&lang=js&"
export * from "./DropZoneTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports